// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bgL7","tabsBox":"styles_tabsBox__1jH9H","createButton":"styles_createButton__2QYM2"};